import { useState, useContext, useEffect } from 'react';
import { Avatar, Button, Dialog, DialogActions, DialogContent, Grid, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { Businesses } from 'lib/api';
import { BUSINESSES_ACTIONS } from 'context/businesses/businessReducer';
import { BusinessContext } from 'context/businesses/businessContext';
import SuccessAlert from './SuccessAlert';
import '../dialogs/ApproveBusinessModal/ApproveBusinessModal.css';

const { HIDE_REJECT_MODAL, RELOAD_BUSINESSES } = BUSINESSES_ACTIONS;
const RejectBusinessModal = () => {
    const {
        state: { isRejectModalOpen, selectedBusiness },
        dispatch
    } = useContext(BusinessContext);
    const [isLoading, setIsLoading] = useState(false);
    const [isRejected, setIsRejected] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (!isRejectModalOpen) {
            setErrorMessage('');
        }
    }, [isRejectModalOpen]);

    const handleBackButton = () => {
        dispatch({ type: HIDE_REJECT_MODAL });
    };

    const handleOnClick = async () => {
        setIsLoading(true);
        setErrorMessage('');

        try {
            await Businesses.reject(selectedBusiness.id_business);

            dispatch({ type: HIDE_REJECT_MODAL });
            setIsRejected(true);
            setIsLoading(false);
            dispatch({ type: RELOAD_BUSINESSES });
        } catch (error) {
            setIsLoading(false);
            setErrorMessage(error?.response?.data?.message || 'An unexpected error ocurred. Please try again.');
        }
    };

    const handleCloseAlertClick = () => {
        setIsRejected(false);
    };

    return (
        <>
            <Dialog open={isRejectModalOpen} onClose={() => {}} maxWidth="lg">
                <DialogContent sx={{ width: '605px', padding: '32px 40px' }}>
                    <Grid container alignItems="center">
                        <Grid item xs={2} sx={{ textAlign: 'center' }}>
                            <Avatar sx={{ bgcolor: '#F7F8F9' }}>
                                <ErrorOutlineIcon sx={{ color: '#FF9E43' }} />
                            </Avatar>
                        </Grid>
                        <Grid item xs={10}>
                            <Typography className="dialog-title">Are you sure you want to reject request?</Typography>
                        </Grid>
                    </Grid>
                    {errorMessage && (
                        <Typography className="text-error">
                            There was an error trying to reject the applicant.
                            {errorMessage}
                        </Typography>
                    )}
                    <DialogActions sx={{ marginTop: '54px' }}>
                        <Button
                            variant="outlined"
                            sx={{ color: '#7D95A5', borderColor: '#7D95A5' }}
                            onClick={handleBackButton}
                            disabled={isLoading}>
                            Cancel
                        </Button>

                        <Button
                            variant="contained"
                            sx={{ backgroundColor: '#FF9E43', borderColor: '#FF9E43' }}
                            disabled={isLoading}
                            onClick={handleOnClick}>
                            Confirm
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <SuccessAlert
                open={isRejected}
                title="Request Successfully Rejected"
                description="Business will receive a rejection email"
                onAlertClose={handleCloseAlertClick}
            />
        </>
    );
};

export default RejectBusinessModal;
